// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2zxLD","description":"PatientConsentPreview_description__3QI5a"};